import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomeButton from "~/components/Button";
import PermissionGate from "~/components/PermissionGate";
import EmployeeLayout from "./components/EmployeeLayout";
import { Card } from "primereact/card";
import EmployeesDataTable from "./components/EmployeesDataTable";
import useEmployeeRegistry from "./useEmployeeRegistry";

const Employee = () => {
  const navigate = useNavigate();
  const { id: entityId } = useParams();
  const {
    loading,
    searchQuery,
    debouncedSearchTerm,
    isDataAvailable,
    employees,
    totalRecords,
    page,
    rows,
    handleSearchChange,
    onPageChange,
    onSortChange,
    sortBy,
    sortOrder,
  } = useEmployeeRegistry();

  return (
    <EmployeeLayout>
      <h1 className="heading mb-4">
        <i
          className="pi pi-arrow-left folder-back-icon"
          onClick={() => navigate(`/entity/${entityId}/dashboard`)}
        />
        Employee Registry
      </h1>
      <div className="flex mb-4">
        <div className="search-input">
          <span className="pi pi-search"></span>
          <input
            type="text"
            placeholder="Search employee by name, ID, or email"
            className="appearance-none outline-none w-full"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <PermissionGate
          resource="employee"
          action="create"
          resourceAttr={{ entity_id: entityId }}
        >
          <CustomeButton
            label={"Add Employee"}
            variant="contained"
            className="access-btn"
            icon="pi pi-plus"
            iconPos="right"
            onClick={() => navigate(`/entity/${entityId}/employee-registry`)}
          />
        </PermissionGate>
      </div>
      <div className="h-full">
        <Card className="gen-card">
          <EmployeesDataTable
            loading={loading}
            isDataAvailable={isDataAvailable}
            employees={employees}
            totalRecords={totalRecords}
            page={page}
            rows={rows}
            onPageChange={onPageChange}
            onSortChange={onSortChange}
            searchQuery={debouncedSearchTerm}
            sortBy={sortBy}
            sortOrder={sortOrder}
          />
        </Card>
      </div>
    </EmployeeLayout>
  );
};
export default Employee;
